import { render, staticRenderFns } from "./mention-list.vue?vue&type=template&id=33419154&scoped=true"
import script from "./mention-list.vue?vue&type=script&lang=js"
export * from "./mention-list.vue?vue&type=script&lang=js"
import style0 from "./mention-list.vue?vue&type=style&index=0&id=33419154&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33419154",
  null
  
)

export default component.exports